import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { MapGeoJSONFeature } from 'maplibre-gl';

import { ButtonComponent } from '@connect-services/client/lib/components/button/button.component';
import { CheckboxComponent, CheckboxState } from '@connect-services/client/lib/components/checkbox/checkbox.component';
import { DEFAULT_MODAL_HEIGHT } from '@connect-services/client/services/map-popup.service';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, CheckboxComponent, RessourcesModule],
    selector: 'app-map-selection-popup',
    templateUrl: './map-selection-popup.component.html',
})
export class MapSelectionPopupComponent {
    public readonly confirmedSelectedEntityIds = output<string[]>();
    public readonly features = input<MapGeoJSONFeature[]>([]);

    protected readonly CheckboxState = CheckboxState;
    protected readonly featuresWithEntityId = computed<
        {
            entityId: string;
            feature: MapGeoJSONFeature;
        }[]
    >(() =>
        this.features().map((feature: MapGeoJSONFeature) => ({
            entityId: feature.properties['entityId'] ?? feature.properties['uuid'],
            feature,
        })),
    );
    protected readonly maxContainerHeight = input<number>(DEFAULT_MODAL_HEIGHT);
    protected readonly selectedEntityIds = signal<Set<string>>(new Set());

    public initializeSelectedEntityIds(entityIds: readonly string[]): void {
        this.selectedEntityIds.set(new Set(entityIds));
    }

    protected confirmSelection(): void {
        this.confirmedSelectedEntityIds.emit([...this.selectedEntityIds()]);
    }

    protected toggle(entityId: string): void {
        this.selectedEntityIds.update((current: Set<string>) => {
            const next = new Set(current);

            if (!next.delete(entityId)) {
                next.add(entityId);
            }

            return next;
        });
    }
}
